import { useState, useEffect, useCallback } from "react";
import { filterBySearch } from "../services/entityFilters.js";

export function useEntityList({ fetchFn, searchFields }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchFn();
      setItems(data);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [fetchFn]);

  useEffect(() => {
    reload();
  }, [reload]);

  const visible = filterBySearch(items, search, searchFields);

  return { items: visible, loading, error, search, setSearch, reload, total: items.length };
}
